import { render, staticRenderFns } from "./MgmInvitedFinish.vue?vue&type=template&id=2973f13c"
import script from "./MgmInvitedFinish.vue?vue&type=script&lang=js"
export * from "./MgmInvitedFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports